import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { Box, Chip, LinearProgress, Stack } from '@mui/material';

import useNotification from '../../../../../../core/hooks/use_notification';
import { getFoodPartnerOrderNotificationData, getPodsNotificationData, getPopsNotificationData } from '../../../../../../core/utils/notification_utils';
import FormWithoutLocationDivision from './form_without_location_division';
import { getFoodPartnerOrderAction, getFoodPartnerOrderState } from '../../../../../../features/inventory/get_food_partner_order';
import FormWithLocationDivision from './form_with_location_division';
import { getAllPopsAction } from "../../../../../../features/pop/get_all_pops";
import { getAllPodsAction } from "../../../../../../features/pod/get_all_pods";
import PageHeader from '../../../../../common/page_header';
import { ROUTE_FOOD_PARTNER_ORDERS } from '../../../../../../core/constants';
import UpdateStatusButtons from "../common/update_status_buttons";

const FoodPartnerOrderEditForm = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { showErrorMessage } = useNotification();
    const location = useLocation();
    const { foodPartnerOrderId } = useParams();

    const getFoodPartnerOrder = useSelector(getFoodPartnerOrderState);

    const [action, setAction] = useState(location?.state?.action);

    useEffect(() => {
        dispatch(getAllPopsAction())
            .then(response => showErrorMessage(getPopsNotificationData(response)));
        dispatch(getAllPodsAction())
            .then(response => showErrorMessage(getPodsNotificationData(response)));
        dispatch(getFoodPartnerOrderAction(foodPartnerOrderId))
            .then(response => showErrorMessage(getFoodPartnerOrderNotificationData(response)));
    }, [dispatch, foodPartnerOrderId, showErrorMessage, action]);

    const renderView = () => {
        if (getFoodPartnerOrder?.loading) {
            return (
                <Box mt={ 6 } width="100%">
                    <LinearProgress/>
                </Box>
            );
        }

        if (getFoodPartnerOrder?.data) {
            if (getFoodPartnerOrder?.data?.locationDivision) {
                return (
                    <FormWithLocationDivision
                        action={ action }
                        setAction={ setAction }/>
                );
            } else {
                return (
                    <FormWithoutLocationDivision
                        action={ action }
                        setAction={ setAction }/>
                );
            }
        }

        return null;
    };

    return (
        <Box sx={ { display: 'flex', flexDirection: 'column', flexGrow: 1, gap: 3 } }>
            <PageHeader
                title={ getFoodPartnerOrder?.data ? `Edycja zamówienia: ${ getFoodPartnerOrder.data.title }` : "Edycja zamówienia" }
                showBack={ true }
                onBack={ () => navigate(ROUTE_FOOD_PARTNER_ORDERS) }
                titleAdornment={
                    getFoodPartnerOrder?.data?.purposeType === 'RESERVATION' ? (
                        <Stack direction="row" spacing={ 1 } sx={ { mt: { xs: 1, sm: 0 }, ml: { sm: 2 } } }>
                            <Chip label="Rezerwacje użytkowników" color="success" variant="outlined"
                                  sx={ { fontWeight: 600 } }/>
                        </Stack>
                    ) : null
                }
                actions={
                    getFoodPartnerOrder?.data ? (
                        <UpdateStatusButtons
                            foodPartnerOrderStatus={ getFoodPartnerOrder.data.status }
                            foodPartnerOrderId={ getFoodPartnerOrder.data.id }
                        />
                    ) : null
                }
            />
            { renderView() }
        </Box>
    );
};

export default FoodPartnerOrderEditForm;